import { Box, Avatar, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  logo: {
    width: 44,
    height: 44,
    backgroundColor: "#eeeeee",
  },
});

const TierMedal = ({ image, name, style, className }) => {
  const classes = useStyles();

  return (
    <Box style={style} className={className}>
      <Avatar className={classes.logo} src={image} alt={name}></Avatar>
    </Box>
  );
};

export default TierMedal;
